import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Modal, Input, Select, TimePicker,Form,Space, Row, InputNumber, Radio } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import AttachIcon from "../../assets/icons/attach.svg";
import { BASE_URL, UpdateLegalEntities } from '../../utils/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';



const LegalEntitiesForm = ({ open, onCancel, initialValues }) => {

  const [panFileUrl, setPanFileUrl] = useState(null);
  const [gstinFileUrl, setGstinFileUrl] = useState(null);
  const [tanFileUrl, setTanFileUrl] = useState(null);
  const [pfFileUrl, setPfFileUrl] = useState(null);
  const [esiFileUrl, setEsiFileUrl] = useState(null);
  const [panNumber, setPanNumber] = useState("");
  const [gstinNumber, setGstinNumber] = useState("");
  const [tanNumber, setTanNumber] = useState("");
  const [pfNumber, setPfNumber] = useState("");
  const [esiNumber, setEsiNumber] = useState("");



  useEffect(() => {

    if(initialValues){
        setPanFileUrl(initialValues?.panFileUrl)
        setGstinFileUrl(initialValues?.gstinFileUrl)
        setTanFileUrl(initialValues?.tanFileUrl)
        setPfFileUrl(initialValues?.pfFileUrl)
        setEsiFileUrl(initialValues?.esiFileUrl)
        setPanNumber(initialValues?.panNumber)
        setGstinNumber(initialValues?.gstinNumber)
        setTanNumber(initialValues?.tanNumber)
        setPfNumber(initialValues?.pfNumber)
        setEsiNumber(initialValues?.esiNumber)
    }
},[open])
const editLegalEntities = (file, name) => {
    const fetchData = async () => {
      const token = localStorage.getItem("authToken");
      const formData = new FormData();
      formData.append("panFileUrl", panFileUrl);
      formData.append("panNumber", panNumber);
      formData.append("pfFileUrl", pfFileUrl);
      formData.append("pfNumber", pfNumber);
      formData.append("gstinFileUrl", gstinFileUrl);
      formData.append("gstinNumber", gstinNumber);
      formData.append("tanFileUrl", tanFileUrl);
      formData.append("tanNumber", tanNumber);
      formData.append("esiFileUrl", esiFileUrl);
      formData.append("esiNumber", esiNumber);

      const response = await fetch(`${BASE_URL}/${UpdateLegalEntities}`, {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        
        console.log("data", data);
        onCancel();
      } else {
        const data = await response.json();
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.log("errdata", data);
      }
    };
    fetchData();
  };
  const handleGstinNumber = useCallback((value) => {
    if(value.target.value.length < 13)setGstinNumber(() => value.target.value);
  }, []);
  const handleGstin = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (
        file.type.startsWith("image/")
      ) {
        setGstinFileUrl(file);
      } else {
        alert("Select image only.");
      }
    }
  };
  const handleTanNumber = useCallback((value) => {
    if(value.target.value.length < 13)setTanNumber(() => value.target.value);
  }, []);
  const handleTan = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (
        file.type.startsWith("image/")
      ) {
        setTanFileUrl(file);
      } else {
        alert("Select image only.");
      }
    }
  };
  const handlePfNumber = useCallback((value) => {
    if(value.target.value.length < 13)setPfNumber(() => value.target.value);
  }, []);
  const handlePf = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (
        file.type.startsWith("image/")
      ) {
        setPfFileUrl(file);
      } else {
        alert("Select image only.");
      }
    }
  };
  const handleEsiNumber = useCallback((value) => {
    if(value.target.value.length < 13)setEsiNumber(() => value.target.value);
  }, []);
  const handleEsi = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (
        file.type.startsWith("image/")
      ) {
        setEsiFileUrl(file);
      } else {
        alert("Select image only.");
      }
    }
  };

  const handlePanNumber = useCallback((value) => {
    if(value.target.value.length < 13)setPanNumber(() => value.target.value);
  }, []);
  const handlePan = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (
        file.type.startsWith("image/")
      ) {
        setPanFileUrl(file);
      } else {
        alert("Select image only.");
      }
    }
  };
  return (
 
    <Modal title="Edit Legal Entities"
    open={open}
    className='ShiftModal'
    okButtonProps={{ style: { background: 'grey' } }}
    //  onOk={handleOk}
      onCancel={onCancel} footer={null}
     >
      <ToastContainer position="top-right" autoClose={2000} />

      <div className=" mt-2">
        <div className="bg-[#EDF3FD] rounded-[15px] px-3 pt-3 pb-4">
          
              <div className="block  mb-1">
              <div className="relative mb-3">
                <label className='!my-1'>Pan Number</label>
                <div className='relative'>
                  <Input
                     className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
                    type="text"
                    placeholder="Pan No"
                    value={panNumber}
                    onChange={handlePanNumber}
                  />
                  <label className="absolute right-3.5 top-1 flex items-center cursor-pointer">
                    <img className='mt-2' src={AttachIcon} />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handlePan}
                    />
                  </label>
                </div>
              </div>
              <div className="relative mb-3">
                <label className='my-1'>Gstin Number</label>
                <div className='relative'>
                  <Input
                  className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
                    type="text"
                    placeholder="Gstin No"
                    value={gstinNumber}
                    onChange={handleGstinNumber}
                  />
                  <label className="absolute right-3.5 top-1 flex items-center cursor-pointer">
                    <img className='mt-2' src={AttachIcon} />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handleGstin}
                    />
                  </label>
                </div>
              </div>
              <div className="relative mb-3">
                <label className='my-1'>Pf Number</label>
                <div className='relative'>
                  <Input
                  className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
                    type="text"
                    placeholder="Pf No"
                    value={pfNumber}
                    onChange={handlePfNumber}
                  />
                  <label className="absolute right-3.5 top-1 flex items-center cursor-pointer">
                    <img className='mt-2' src={AttachIcon} />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handlePf}
                    />
                  </label>
                </div>
              </div>
              <div className="relative mb-3">
                <label className='my-1'>Esi Number</label>
                <div className='relative'>
                  <Input
                    className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
                      type="text"
                      placeholder="Esi No"
                      value={esiNumber}
                      onChange={handleEsiNumber}
                  />
                  <label className="absolute right-3.5 top-1 flex items-center cursor-pointer">
                    <img className='mt-2' src={AttachIcon} />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handleEsi}
                    />
                  </label>
                  </div>
              </div>
              <div className="relative">
              <label className='my-1'>Tan Number</label>

                  <div className='relative'>
                    <Input
                    className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
                      type="text"
                      placeholder="Tan No"
                      value={tanNumber}
                      onChange={handleTanNumber}
                    />
                    <label className="absolute right-3.5 top-1 flex items-center cursor-pointer">
                      <img className='mt-2' src={AttachIcon} />
                      <input
                        type="file"
                        className="hidden"
                        onChange={handleTan}
                      />
                    </label>
                  </div>
                </div>
                  
              </div>
             
       
        </div>
       
      </div>
      <div className="text-center mt-4">
                <Button
                  className="!border-[#6198ED] bg-[#6198ED] text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-4 h-auto !text-sm !outline-none"
                  onClick={editLegalEntities}
                >
                  <span className="font-sbold">+Edit Legal Entities</span>
                </Button>
              </div>
   </Modal>
  );
};

export default LegalEntitiesForm;
